import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

import { Router } from '@angular/router';
import { UserService } from 'app/service/auth/user.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ExaminadorEstabelecimentoService } from 'app/service/api/exame/examinador-estabelecimento.service';

@Component({
    selector: 'app-estabelecimento-lista',
    templateUrl: './lista.component.html',
    styleUrls: ['./lista.component.scss']
})
export class EstabelecimentoListaComponent implements OnInit {

    loading: boolean;
    private _unsubscribeAll: Subject<void>;
    //TODO
    IdEstabelecimento: string;
    constructor(
        private toastr: ToastrService,
        private userSvc: UserService,
        private router: Router,
        private estabSvc: ExaminadorEstabelecimentoService,
        private _fuseSidebarService: FuseSidebarService,
    ) { 
        this._unsubscribeAll = new Subject();
    }

    estabelecimentos: any[];

    sel(est) {

        this.userSvc.RefreshToken(est.IdEstabelecimento)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe( res =>  this.router.navigate(['app']) );
        this._fuseSidebarService.getSidebar('quickPanel').close();
    }

    ngOnInit() {
        this.userSvc.onLogon
        .pipe( takeUntil(this._unsubscribeAll) )
        .subscribe(()=>this.fill());
        if( this.userSvc.getUser() != null )
        { this.fill();}
    }

    fill(){
        this.loading = true;
        this.estabSvc.listCached({})
        .pipe( finalize(()=> this.loading = false) )
        .subscribe(
            data => this.estabelecimentos = data,
            err  => this.toastr.error(err.error.ExceptionMessage, 'Ocorreu um erro na tentativa de listar os estabelecimentos')
        );
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
